const EFTA_COUNTRIES = [
  'CH',
  'IS',
  'LI',
  'NO',
];

export default EFTA_COUNTRIES;
